import { useState } from 'react';
import SelectProps from './SelectProps';
import "./Select.scss";


const Select = (props: SelectProps) => {
    
    const [selectedOption, setSelectedOption] = useState(props.selectedOption1 || "");
    const handleChange = (e: any) => {
        setSelectedOption(e.target.value)
        props.onChange(e.target.value);
        props.onBlur(e.target.value);
        props.value(props.id , e.target.value)
    }

    return (
        <div  className='select' aria-describedby={props?.id || ""} tabIndex={props?.tabIndex || undefined}>
            <select
                aria-describedby= {props?.ariaDescribedby || ""}
                aria-required = {props?.isRequired || false}
                title={props?.title|| ""}
                autoFocus={props.isAutoFocus || false}
                className="select-text"
                name={props.name}
                id={props.id}
                value={selectedOption}
                onChange={e => handleChange(e)}>
                <option  value=""></option>
                {props.data.map(option => (
                    <option key={option.questionID} value={option.question}>{option.question}</option>
                ))}
            </select>
            <span className="select-bar"></span>
            <span className="select-highlight"></span>
            <label className='select-label' htmlFor={props.id}>{props.label}</label>
        </div>
    );
}

export default Select;